import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectGamesLoading, selectLastPlayedGames } from '@/store/selectors/gamesSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import GamesStreamlineSection, {
  GamesStreamlineType,
} from '@/components/shared/games/GamesStreamlineSection';
import { LastPlayedCategory } from '@/models/game-category.type';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';

const LastPlayed = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectGamesLoading);
  const games = useSelector(selectLastPlayedGames);

  const intl = useIntl();

  if (!isAuthenticated || games.length === 0) {
    return null;
  }

  return (
    <GamesSection>
      <GamesSectionHeader
        title={intl.formatMessage({ id: 'games.categories.lastPlayed' })}
        totalGames={games.length}
        categoryPath="/games/last-played"
      />
      <GamesStreamlineSection
        type={GamesStreamlineType.Single}
        visibleGames={10}
        loading={loading}
        games={games}
        category={LastPlayedCategory.LastPlayed}
      />
    </GamesSection>
  );
};

export default LastPlayed;
